import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white gap-3 py-4" }
const _hoisted_2 = { class: "flex flex-col px-5" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "text-lg font-semibold text-black" }
const _hoisted_5 = { class: "w-full mb-2 border-b border-b-gray-200" }
const _hoisted_6 = { class: "flex gap-2 mt-1 px-5" }
const _hoisted_7 = { class: "child-wrapper px-5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = { class: "form-group flex justify-between items-center" }
const _hoisted_11 = {
  for: "firstName",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_12 = { class: "form-group flex justify-between items-center" }
const _hoisted_13 = {
  for: "lastName",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_14 = { class: "form-group flex justify-between items-center" }
const _hoisted_15 = {
  for: "email",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_16 = { class: "flex flex-col gap-1 w-[60%]" }
const _hoisted_17 = {
  key: 0,
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_18 = {
  key: 1,
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_19 = { class: "form-group flex justify-between items-center" }
const _hoisted_20 = {
  for: "password",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_21 = { class: "flex flex-col gap-1 w-[60%]" }
const _hoisted_22 = {
  key: 0,
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_23 = { class: "form-group flex justify-between items-center" }
const _hoisted_24 = {
  for: "studentNumber",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onSubmit"]
const _hoisted_27 = { class: "form-group flex justify-between items-center border-b-2 border-gray-200 pb-4" }
const _hoisted_28 = {
  for: "grade",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_29 = {
  key: 0,
  class: "form-group flex justify-between items-center border-b-2 border-gray-200 pb-4"
}
const _hoisted_30 = {
  for: "lockedJourneys",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "active" }, "Active", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "deactivated" }, "Deactivated", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "archived" }, "Archived", -1)
const _hoisted_34 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "form-group flex justify-between items-center border-b-2 border-gray-200 pb-4"
}
const _hoisted_36 = {
  for: "lockedJourneys",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_37 = { value: "catchup" }
const _hoisted_38 = { value: "assessment" }
const _hoisted_39 = { value: "none" }
const _hoisted_40 = { class: "form-group flex justify-between items-center border-b-2 border-gray-200 pb-4" }
const _hoisted_41 = {
  for: "country",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_42 = { key: 2 }
const _hoisted_43 = ["onSubmit"]
const _hoisted_44 = { class: "flex flex-row gap-3 justify-between" }
const _hoisted_45 = { class: "text-sm font-medium text-gray-700 mb-3" }
const _hoisted_46 = { class: "form-group flex justify-between gap-3 flex-col w-[60%]" }
const _hoisted_47 = { class: "form-group flex justify-between items-center" }
const _hoisted_48 = ["for"]
const _hoisted_49 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_50 = ["value"]
const _hoisted_51 = {
  key: 0,
  class: "form-group flex justify-between items-center"
}
const _hoisted_52 = {
  for: "assessmentLevel",
  class: "text-sm font-medium text-[#344054]"
}
const _hoisted_53 = ["value"]
const _hoisted_54 = {
  key: 1,
  class: "ml-auto text-sm font-medium text-[#344054] -mt-3 -mb-2"
}
const _hoisted_55 = { class: "form-group flex justify-between items-center" }
const _hoisted_56 = {
  for: "grade",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", { value: "en-ZA" }, "English ZA", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "en-GB" }, "English GB", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("option", { value: "en-AU" }, "English AU", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("option", { value: "af-ZA" }, "Afrikaans", -1)
const _hoisted_61 = [
  _hoisted_57,
  _hoisted_58,
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = { class: "w-full flex flex-col gap-3 items-center justify-center mt-2 px-5" }
const _hoisted_63 = { class: "w-full flex gap-4" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { class: "relative sm:my-8 p-3" }
const _hoisted_68 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_69 = { class: "flex flex-col items-center px-12 py-8" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = {
  key: 0,
  class: "mt-5 font-medium text-xl text-gray-900"
}
const _hoisted_73 = {
  key: 1,
  class: "mt-5 font-medium text-xl text-gray-900"
}
const _hoisted_74 = {
  key: 2,
  class: "font-normal text-sm text-gray-400 mt-2 text-center"
}
const _hoisted_75 = { class: "font-medium" }
const _hoisted_76 = {
  key: 3,
  class: "font-normal text-sm text-gray-400 mt-2 text-center"
}
const _hoisted_77 = { class: "font-medium" }
const _hoisted_78 = { class: "mt-8 flex gap-4 text-base w-full" }

import {
  computed,
  onMounted,
  ref,
} from "vue";
import { useLearnerStore } from "@/stores/learnerStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useFilterStore } from "@/stores/filterStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useUserStore } from "@/stores/userStore";
import { Subject } from "@/interfaces/subject.interface";
import { Class, Learner } from "@/interfaces/learner.interface";
import { SchoolStructureClassGroup } from "@/interfaces/school-structure.interface";

// Define the props that the component accepts

export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateLearnerComponent',
  props: {
  gradeLevel: {
    type: Number,
    default: 0,
    required: false,
  },
  preferredLanguage: {
    type: String,
    default: "en-ZA",
    required: false,
  },
  subject: {
    type: String,
    default: "",
    required: false,
  },
  classId: {
    type: String,
    default: "",
    required: false,
  },
  selectedStudents: {
    type: Array,
    required: false,
  },
},
  emits: ["closeUpdate"],
  setup(__props, { emit }) {

const props = __props;



// Initialize the stores for learners, school, and subjects
const learnerStore = useLearnerStore();
const schoolStore = useSchoolStore();
const filterStore = useFilterStore();
const subjectStore = useSubjectStore();
const userStore = useUserStore();

// Initialize reactive references
const selectedStudents = ref<string[]>([]);
const singleEdit = ref(true);
const selectedJourney = ref("");
const selectedEnglishClass = ref("");
const selectedMathsClass = ref("");
const activeTab = ref("personal");
const initialFormData = ref({} as any);
const showEditComplete = ref(false);
const disabledBtn = ref(false);
const response = ref("");
const validpassword = ref(false);
const validEmail = ref(true);
const validEmailExists = ref(false);
const lockedJourneys = ref({
  assessment: false,
  catchup: false,
});


//Initialize selectedStudents with the passed prop
selectedStudents.value = props.selectedStudents as string[];

// Compute the form data for the learner
const formData = computed(() => {
  // Getting the learner details from the store
  const learnerDetails = learnerStore.getSchoolLearners.filter(
    (learner) => learner._id == selectedStudents.value[0]
  );
  
  // Get the locked journeys of the learner
  const lockedJourneys = learnerDetails[0].settings.lockedJourneys;
  const selectedLockedJourney = lockedJourneys.catchup
    ? "catchup"
    : lockedJourneys.assessment
      ? "assessment"
      : "";

  // Get the assessment level of the learner
  const assessmentLevel = learnerDetails[0].assessmentStates.filter(
    (state) => state.subject.toLowerCase() === props.subject.toLowerCase()
  );

  // Clone the assessment state to avoid reference issues
  const assessmentLevelUpdate = assessmentLevel[0]
    ? JSON.parse(JSON.stringify(assessmentLevel[0]))
    : {};

  // Return the learner object
  let learner = {
    firstName: learnerDetails[0].firstName,
    lastName: learnerDetails[0].lastName,
    email: learnerDetails[0].email,
    password: "",
    studentNumber: learnerDetails[0].studentNumber,
    grade: learnerDetails[0].grade,
    lockedJourneys: selectedLockedJourney,
    country: learnerDetails[0]?.country,
    newAssessment: assessmentLevelUpdate,
    assessment: assessmentLevel[0],
    preferredLang: learnerDetails[0]?.preferredLang,
    classes: learnerDetails[0].classes,
    status: learnerDetails[0].status,
  };

  return learner as any;
});

// Function to check if two objects are deeply equal
const deepEqual = (changes: any, initialValues: any) => {
  if (changes == initialValues) return true;

  // Check if the objects are not objects or are null
  if (
    typeof changes !== "object" ||
    typeof initialValues !== "object" ||
    changes === null ||
    initialValues === null
  ) {
    return false;
  }

  // Get the keys of the objects
  const keys1 = Object.keys(changes);
  const keys2 = Object.keys(initialValues);

  // Check if the keys are not equal
  if (keys1.length !== keys2.length) return false;

  // Check if the keys are not equal
  for (let key of keys1) {
    if (!keys2.includes(key) || !deepEqual(changes[key], initialValues[key])) {
      return false;
    }
  }

  // Return true if the objects are deeply equal
  return true;
};

// Compute the assessment levels based on the subject
const getAssessmentLevels = computed(() => {
  // Define the assessment levels for Maths and English subjects
  const assessmentLevelMAth = [
    "MATHS_JUNIOR_PRIMARY",
    "MATHS_SENIOR_PRIMARY",
    "MATHS_SENIOR_PRIMARY_V2",
    "MATHS_JUNIOR_HIGH",
  ];

  const assessmentLevelEnglish = [
    "ENGLISH_JUNIOR_HIGH",
    "ENGLISH_SENIOR_PRIMARY",
  ];

  // Return the assessment levels based on the subject
  return props.subject == "maths"
    ? assessmentLevelMAth
    : assessmentLevelEnglish;
});

// Emit event setup


// Function to update the lockedJourneys state based on selected journey
const updateLockedJourneys = () => {
  lockedJourneys.value = {
    assessment: selectedJourney.value === "assessment" ? true : false,
    catchup: selectedJourney.value === "catchup" ? true : false,
  };
};

// Transform the assessment level text
const formatText = (input: string) => {
  // Remove "ENGLISH_" from the beginning
  let cleanedText = "";

  if (props.subject.toLocaleLowerCase() == "english") {
    // Step 1: Remove "ENGLISH_" from the beginning
    cleanedText = input.replace("ENGLISH_", "");
  }

  if (props.subject.toLocaleLowerCase() == "maths") {
    // Step 1: Remove "MATHS_" from the beginning
    cleanedText = input.replace("MATHS_", "");
  }

  // Step 2: Convert to lowercase
  cleanedText = cleanedText.toLowerCase();

  // Step 3: Replace underscores with spaces
  cleanedText = cleanedText.replace(/_/g, " ");

  // Step 4: Capitalize the first letter of each word
  cleanedText = cleanedText.replace(/\b\w/g, (char) => char.toUpperCase());

  return cleanedText;
};

// Cance single learner edit
const cancelSingleEdit = () => {
  singleEdit.value = false;
  showEditComplete.value = false;
  emit("closeUpdate");
};

const activeClass = ref(
  "p-[7px] text-blue-600 font-normal border-b-blue-600 border-b-[3px]"
);

const inactiveClass = ref(
  "p-[7px] text-gray-500 font-normal border-b-white border-b-[2px]"
);

const selectedClasses = ref<{ [key: string]: string }>({});
const previousSelectedClasses = ref<{ [key: string]: string }>({});
const subjects = computed(() => (subjectStore.getSubjects) as Subject[]);

// Compute classes for a given subject
const getClassesForSubject = (subjectName: string) => {
  const learnerDetails = learnerStore.getSchoolLearners.filter(
    (learner) => learner._id == selectedStudents.value[0]
  )[0];

  const grade = learnerDetails.grade;
  const subjectId = subjectStore.getSubjectIdByName(subjectName);

  if (!subjectId) {
    console.error(`Subject "${subjectName}" not found`);
    return [];
  }

  let filteredClasses = schoolStore.getSchoolStructure?.classGroups.filter(
    (group) => group.gradeLevel === grade && group.subject === subjectId
  ) ?? [];

  // Get learnerDetails current classes for this subject
  const learnerClasses = learnerDetails.classes.filter(
    (cls: Class) => cls.subject._id === subjectId
  );

  if (learnerClasses){
    //Add the learnerClasses to the filteredClasses
    filteredClasses.push(...learnerClasses as any);
  }
  
  // Remove duplicates
  filteredClasses = filteredClasses.filter(
    (group: SchoolStructureClassGroup, index: number, self: any) =>
      index ===
      self.findIndex(
        (t: SchoolStructureClassGroup) =>
          t._id === group._id &&
          t.name === group.name &&
          t.preferredLanguage === group.preferredLanguage
      )
  );

  return filteredClasses?.map((group: SchoolStructureClassGroup) => ({
    name: group.name,
    id: group._id,
    preferredLanguage: group.preferredLanguage,
  }));
};

onMounted(() => {
  subjects.value.forEach((subject) => {
    const learnerClass = formData.value.classes?.find((cls: Class) => {
      return cls.subject && String(cls.subject._id) === String(subject.id);
    });

    selectedClasses.value[subject.id] = learnerClass ? learnerClass._id : "";
    previousSelectedClasses.value[subject.id] = learnerClass
      ? learnerClass._id
      : "";
  });

  initialFormData.value = JSON.parse(JSON.stringify(formData.value));
});

const updateLearnerDetails = async () => {
  // Check if the password is valid
  if (
    formData.value.password.length > 0 &&
    formData.value.password.length < 6
  ) {
    validpassword.value = true;
    return;
  }
  if (!validEmail.value || validEmailExists.value === true) {
    return false;
  }

  //disable button once clicked
  disabledBtn.value = true;

  let changes = {} as any;

  // Prepare the class update payload
  const learnerDetails = learnerStore.getSchoolLearners.filter(
    (learner) => learner._id == selectedStudents.value[0]
  )[0];

  const classUpdate = {
    classes: subjects.value.map((subject: Subject) => ({
      currentClass:
        learnerDetails.classes?.find((cls: Class) => cls.subject._id === subject.id)
          ?._id || "",
      newClass: selectedClasses.value[subject.id],
    })),
  };

  // Loop through the form data and check for changes
  Object.keys(formData.value as any).forEach((key: any) => {
    if (!deepEqual(formData.value[key] as any, initialFormData.value[key])) {
      // Check if the key is assessment to make needed changes
      if (key == "newAssessment") {
        key = "assessmentUpgrades";
        changes[key] = [
          {
            _id: formData.value.assessment._id,
            type: formData.value.assessment.type,
            subject: formData.value.assessment.subject,
            newType: formData.value.newAssessment.type,
          },
        ];
      }
      // Check if the key is lockedJourneys to make needed changes
      else if (key == "lockedJourneys") {
        changes[key] = {
          assessment: formData.value[key] == "assessment" ? true : false,
          catchup: formData.value[key] == "catchup" ? true : false,
        };
      } else {
        // Add the changes to the changes object
        changes[key] = formData.value[key];
      }
    }
  });

  // Update classes if there's any changes
  classUpdate.classes.forEach((classItem) => {
    if (
      classItem.currentClass != classItem.newClass ||
      classItem.newClass != ""
    ) {
      changes = { ...classUpdate, ...changes };
    }
  });

  // Check if there are no changes and close the modal without hitting the endpoint
  if (Object.keys(changes).length === 0) {
    //Hide modal without hitting the endpoint
    cancelSingleEdit();
    return;
  }

  //Perform bulk update through the store updateLearner(learnerId:any ,updateClassDetails: any)
  const request = await learnerStore.updateLearner(
    selectedStudents.value,
    changes
  );

  // Show the response modal
  if (request) {
    response.value = "success";
    singleEdit.value = false;
    showEditComplete.value = true;
  } else {
    response.value = "failed";
    showEditComplete.value = true;
  }
};

const handleClassChange = (
  subjectId: string,
  newClassId: string,
  previousClassId: string
) => {
  previousSelectedClasses.value[subjectId] = newClassId;
};

const validateEmail = async () => {
  if (initialFormData.value.email === formData.value.email) {
    validEmail.value = true;
    return;
  }
  try {
    let response = await learnerStore.validateEmail(formData.value.email);
    if (response === true) {
      validEmail.value = true; //email already exists
      validEmailExists.value = true;
    } else {
      validEmail.value = true;
      validEmailExists.value = false;
    }
  } catch (error) {
    validEmail.value = false; //invalid email
    validEmailExists.value = false;
  }
};

const isValidAssessmentLevel = ref(true);

const validateAssessmentLevel = () => {
  const currentType = formData.value.assessment?.type;
  const newType = formData.value.newAssessment.type;
  isValidAssessmentLevel.value = assessmentLevelValidation(currentType, newType);
  if (!isValidAssessmentLevel.value) {
    disabledBtn.value = true;
  } else {
    disabledBtn.value = false;
  }
};

const assessmentLevelValidation = (currentType: string, newType: string) => {
  const assessmentLevels = {
    "MATHS_JUNIOR_PRIMARY": 0,
    "MATHS_SENIOR_PRIMARY": 1,
    "MATHS_SENIOR_PRIMARY_V2": 1,
    "MATHS_JUNIOR_HIGH": 2,
    "ENGLISH_SENIOR_PRIMARY": 0,
    "ENGLISH_JUNIOR_HIGH": 1
  } as any;
  if (Math.abs(assessmentLevels[currentType] - assessmentLevels[newType]) > 1) {
    return false;
  }
  return true;
};

return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl',
      open: singleEdit.value,
      onLocalModalOpen: cancelSingleEdit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("update_student.title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(activeTab.value == 'personal' ? activeClass.value : inactiveClass.value
            ),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'personal'))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("update_student.personal.personal")), 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(activeTab.value == 'settings' ? activeClass.value : inactiveClass.value
            ),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'settings'))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("update_student.settings.settings")), 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(activeTab.value == 'subject' ? activeClass.value : inactiveClass.value
            ),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'subject'))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("update_student.subject.subject")), 1)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (activeTab.value == 'personal')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(updateLearnerDetails, ["prevent"]),
                    id: "update-learner-personal",
                    class: "flex flex-col gap-5"
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("update_student.personal.first_name")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "firstName",
                        id: "firstName",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.firstName) = $event)),
                        class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 w-[60%] focus:outline-none focus:ring-2 focus:ring-blue-500 text-base font-normal text-gray-900"
                      }, null, 512), [
                        [_vModelText, formData.value.firstName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("update_student.personal.last_name")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "lastName",
                        id: "lastName",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.lastName) = $event)),
                        class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 w-[60%] focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                      }, null, 512), [
                        [_vModelText, formData.value.lastName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("update_student.personal.email")), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          name: "email",
                          id: "email",
                          onBlur: validateEmail,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.email) = $event)),
                          class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                        }, null, 544), [
                          [_vModelText, formData.value.email]
                        ]),
                        (!validEmail.value)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_17, _toDisplayString(_ctx.$t("update_student.personal.email_invalid")), 1))
                          : _createCommentVNode("", true),
                        (validEmailExists.value)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_18, _toDisplayString(_ctx.$t("update_student.personal.email_exists")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("update_student.personal.password")), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          name: "password",
                          id: "password",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.password) = $event)),
                          class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 w-[100%] focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                        }, null, 512), [
                          [_vModelText, formData.value.password]
                        ]),
                        (validpassword.value)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_22, _toDisplayString(_ctx.$t("update_student.personal.message")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("update_student.personal.student_number")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "studentNumber",
                        id: "studentNumber",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.studentNumber) = $event)),
                        class: "border border-gray-300 rounded-lg shadow-box px-3 py-2 w-[60%] focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                      }, null, 512), [
                        [_vModelText, formData.value.studentNumber]
                      ])
                    ])
                  ], 40, _hoisted_9)
                ]))
              : _createCommentVNode("", true),
            (activeTab.value == 'settings')
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(updateLearnerDetails, ["prevent"]),
                    id: "update-learner-settings",
                    class: "flex flex-col gap-5"
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("update_student.settings.grade")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "grade",
                        id: "grade",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.grade) = $event)),
                        class: "p-2 w-[60%] border border-gray-300 rounded-lg shadow-box focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                      }, null, 512), [
                        [_vModelText, formData.value.grade]
                      ])
                    ]),
                    (_unref(userStore).isInternalAdmin || _unref(userStore).isSchoolGroupAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("update_student.settings.status")), 1),
                          _withDirectives(_createElementVNode("select", {
                            name: "status",
                            id: "status",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.status) = $event)),
                            class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                          }, _hoisted_34, 512), [
                            [_vModelSelect, formData.value.status]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(userStore).isClassGroupAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("update_student.settings.locked_journeys")), 1),
                          _withDirectives(_createElementVNode("select", {
                            name: "lockedJourneys",
                            id: "lockedJourneys",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.lockedJourneys) = $event)),
                            onChange: updateLockedJourneys,
                            class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                          }, [
                            _createElementVNode("option", _hoisted_37, _toDisplayString(_ctx.$t("update_student.settings.catchup")), 1),
                            _createElementVNode("option", _hoisted_38, _toDisplayString(_ctx.$t("update_student.settings.assessment")), 1),
                            _createElementVNode("option", _hoisted_39, _toDisplayString(_ctx.$t("update_student.settings.none")), 1)
                          ], 544), [
                            [_vModelSelect, formData.value.lockedJourneys]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("update_student.settings.country")), 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "country",
                        id: "country",
                        readonly: "",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.country) = $event)),
                        class: "cursor-not-allowed w-[60%] border border-gray-300 shadow-box px-[14px] py-[10px] bg-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900"
                      }, null, 512), [
                        [_vModelText, formData.value.country]
                      ])
                    ])
                  ], 40, _hoisted_26)
                ]))
              : _createCommentVNode("", true),
            (activeTab.value == 'subject')
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(updateLearnerDetails, ["prevent"]),
                    id: "update-learner-settings",
                    class: "flex flex-col gap-5"
                  }, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("h3", _hoisted_45, _toDisplayString(_ctx.$t("update_student.subject.class")), 1),
                      _createElementVNode("div", _hoisted_46, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjects.value, (subject) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: subject.id
                          }, [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("label", {
                                for: subject.name + 'Class',
                                class: "text-sm font-medium text-gray-700"
                              }, _toDisplayString(subject.name), 9, _hoisted_48),
                              _withDirectives(_createElementVNode("select", {
                                id: subject.name + 'Class',
                                class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900",
                                "onUpdate:modelValue": ($event: any) => ((selectedClasses.value[subject.id]) = $event),
                                onChange: ($event: any) => (
                        handleClassChange(
                          subject.id,
                          selectedClasses.value[subject.id],
                          previousSelectedClasses.value[subject.id]
                        )
                        )
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getClassesForSubject(
                        subject.name
                      ), (classGroup) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: classGroup.id,
                                    value: classGroup.id
                                  }, _toDisplayString(classGroup.name), 9, _hoisted_50))
                                }), 128))
                              ], 40, _hoisted_49), [
                                [_vModelSelect, selectedClasses.value[subject.id]]
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    (!_unref(userStore).isClassGroupAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t("update_student.subject.assessment_level")), 1),
                          _withDirectives(_createElementVNode("select", {
                            id: "assessmentLevel",
                            class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-[#101828]",
                            placeholder: "select",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.newAssessment.type) = $event)),
                            onChange: validateAssessmentLevel
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAssessmentLevels.value, (classGroup) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: classGroup,
                                value: classGroup
                              }, _toDisplayString(formatText(classGroup)), 9, _hoisted_53))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, formData.value.newAssessment.type]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!isValidAssessmentLevel.value)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_54, _toDisplayString(_ctx.$t("update_student.subject.assessment_level_validation")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t("update_student.subject.language")), 1),
                      _withDirectives(_createElementVNode("select", {
                        id: "english",
                        class: "w-[60%] border border-gray-300 px-[14px] shadow-box py-[10px] bg-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-normal text-gray-900",
                        placeholder: "select",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.preferredLang) = $event))
                      }, _hoisted_61, 512), [
                        [_vModelSelect, formData.value.preferredLang]
                      ])
                    ])
                  ], 40, _hoisted_43)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("button", {
                class: "w-1/2 font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8",
                onClick: cancelSingleEdit
              }, _toDisplayString(_ctx.$t("bulk_learner_edit_component.btn_cancel")), 1),
              _createElementVNode("button", {
                disabled: disabledBtn.value,
                class: _normalizeClass([
            'w-1/2 font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white',
            selectedStudents.value.length === 0
              ? 'bg-gray-300 cursor-not-allowed'
              : '',
            disabledBtn.value ? 'cursor-wait' : 'cursor-pointer'                      
          ]),
                onClick: updateLearnerDetails
              }, [
                (_unref(learnerStore).loader.learner)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                      _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                      _createTextVNode(" " + _toDisplayString(_unref(learnerStore).loadingMessage), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.$t("bulk_learner_edit_component.btn_save")), 1))
              ], 10, _hoisted_64)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      widthClass: 'max-w-lg',
      open: showEditComplete.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", null, [
                (response.value == 'success')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_70, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-green-tick',
                        title: 'rl green tick',
                        "aria-hidden": "true"
                      })
                    ]))
                  : _createCommentVNode("", true),
                (response.value == 'failed')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-red-fail',
                        title: 'rl red fail',
                        "aria-hidden": "true"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (response.value == 'success')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_72, _toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.header")), 1))
                : _createCommentVNode("", true),
              (response.value == 'failed')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_73, _toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.failed_header")), 1))
                : _createCommentVNode("", true),
              (response.value == 'success')
                ? (_openBlock(), _createElementBlock("p", _hoisted_74, [
                    _createElementVNode("span", _hoisted_75, _toDisplayString(formData.value.lastName) + " " + _toDisplayString(formData.value.firstName), 1),
                    _createTextVNode(_toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.success_update")), 1)
                  ]))
                : _createCommentVNode("", true),
              (response.value == 'failed')
                ? (_openBlock(), _createElementBlock("p", _hoisted_76, [
                    _createTextVNode(_toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.changes")) + " ", 1),
                    _createElementVNode("span", _hoisted_77, _toDisplayString(formData.value.lastName) + " " + _toDisplayString(formData.value.firstName), 1),
                    _createTextVNode(_toDisplayString(_ctx.$t("bulk_learner_edit_component.modal.not_successful")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("button", {
                  class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-2 w-full focus:outline-none",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => ((showEditComplete.value = false), cancelSingleEdit()))
                }, _toDisplayString(_ctx.$t("student_table_view.confirm_modal.btn_edit")), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})